/* unplugin-vue-components disabled */import { render } from "./GridItem.vue?vue&type=template&id=c83ad07a&ts=true"
import script from "./GridItem.vue?vue&type=script&lang=ts"
export * from "./GridItem.vue?vue&type=script&lang=ts"

import "./GridItem.vue?vue&type=style&index=0&id=c83ad07a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__